module.exports = __webpack_public_path__ + "img/dark-green-booth-table-4.f4353c0a.png";